import moment from 'moment-timezone'
import Helper from '@/helpers/helper'

export const ordermixins = {
    methods : {
        /**
         * Check if ammend update status will be available after 24 hours after last delivery
         * 
         */
         pastduration(date, duration = 24) {
            const dif = moment().diff(moment(date).utc(), 'hours')
            console.log("diff",date,  dif)
            if(dif <= duration) {
                return true
            } else {
                return false
            }
        },
        /**
         * Group order by dates
         */
         grouporderbydates(orderlist = []) {
            let   newlist = [];
            const format  = 'MM/DD/YYYY'

            orderlist.forEach(order => {
                /**
                 * Don't include order without delivery dates
                 *
                 * Check if order is nested or not
                 * 
                 */
                let orderdata = order;


                if(order.order) {
                    orderdata = order.order
                }  

                const currentdate = Helper.usertimezone().match(/America/i) ? moment().format(format) : Helper.formatdate(moment(), 'MM/DD/YYYY')

                
                // console.log(
                //         orderdata.delivery_date, 
                //         Helper.formatdate(orderdata.delivery_date, 'MM/DD/YYYY'), 
                //         currentdate, 
                //         'order grouping', 
                //         moment(Helper.formatdate(orderdata.delivery_date, 'MM/DD/YYYY')).isBefore(currentdate, 'day'))

                /**
                 * filter order to allow today or later dates only
                 */
                if(!orderdata.delivery_date) {
                    return;
                } else if(moment(Helper.formatdate(orderdata.delivery_date, 'MM/DD/YYYY')).isBefore(currentdate, 'day')) {
                    return;
                }
                
                // moment(orderdata.delivery_date).utc().format(format)
                const date  = Helper.formatdate(orderdata.delivery_date, format);
                const group = newlist.find(g => moment(g.date).isSame(Helper.formatdate(orderdata.delivery_date, format), 'day'));
                
                if(group) {
                    newlist = newlist.map(g => {
                        if(moment(g.date).isSame(Helper.formatdate(orderdata.delivery_date, format), 'day')) {
                            g.orders = [...g.orders, order];
                        }

                        return g;
                    })
                } else {
                    const newgroup = {
                        date     : date,
                        orders   : [order]
                    }

                    newlist = [...newlist, newgroup]
                }
            })



            return newlist.slice().sort((a, b) => new Date(a.date) - new Date(b.date));
        }
    }
    }